import { arrayToMap } from "../util";

const list = [
  {
    name: "屋内型",
    slug: "okunai",
    icon: "resource/img/serv_inside.png",
  },
  {
    name: "屋外型",
    slug: "okugai",
    icon: "resource/img/serv_outside.png",
  },
  {
    name: "屋内型(バイクあり)",
    slug: "okunaiBike",
    icon: "resource/img/serv_inside_bike.png",
  },
  {
    name: "屋外型(バイクあり）",
    slug: "okugaiBike",
    icon: "resource/img/serv_outside_bike.png",
  },
  {
    name: "トランクハウス24",
    slug: "premium",
    icon: "resource/img/serv_premium.png",
    shrink: true,
  },
  {
    name: "バイク",
    slug: "bikeonly",
    icon: "resource/img/serv_motorbike.png",
  },
  {
    name: "屋内型(キャンペーンあり)",
    slug: "okunaiCampaign",
    icon: "resource/img/serv_inside_cp.png",
  },
  {
    name: "屋外型（キャンペーンあり）",
    slug: "okugaiCampaign",
    icon: "resource/img/serv_outside_cp.png",
  },
  {
    name: "トランクハウス24（キャンペーンあり）",
    slug: "premiumCampaign",
    icon: "resource/img/serv_premium_cp.png",
    shrink: true,
  },
  {
    name: "バイク（キャンペーンあり）",
    slug: "bikeonlyCampaign",
    icon: "resource/img/serv_motorbike_cp.png",
  },
];

export const data = {
  list: list,
  bySlug: arrayToMap(list, "slug"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/assetIcon.js